import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService, AdminUser, AdminScopes } from '@app/shared/services/user.service';
import { first } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'app-otp',
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.scss'],
})
export class OtpComponent implements OnInit {
  public loading: boolean = true;
  public user: AdminUser;
  public canViewOtp: boolean = false;
  public canModifyOtp: boolean = false;

  constructor(private userService: UserService, private router: Router) {}

  ngOnInit() {
    this.loading = true;

    this.userService
      .getAuthenticatedUser([AdminScopes.VIEW_OTP])
      .pipe(first())
      .subscribe(
        (adminUser: AdminUser) => {
          if (adminUser) {
            this.user = adminUser;
            this.canViewOtp = this.userService.hasAuthScope(this.user, [AdminScopes.VIEW_OTP]);
            this.canModifyOtp = this.userService.hasAuthScope(this.user, [AdminScopes.MODIFY_OTP]);
            this.loading = false;
          } else {
            this.router.navigate(['login']);
          }
        },
        (err) => {
          this.router.navigate(['home']);
        }
      );
  }

  public goTo(urlStub?: string): void {
    const navigateTo: string[] = ['otp'];
    if (urlStub) {
      navigateTo.push(urlStub);
    }
    this.router.navigate(navigateTo);
  }
}
